'use client';

import { useUserContext } from '@/context/user';
import { useIsMobile } from '@/hooks/use-is-mobile';
import Image from 'next/image';

const TopBanner = () => {
  const [{ isSignedIn }] = useUserContext();

  const { isMobile } = useIsMobile();

  if (isSignedIn) {
    return null;
  }

  const banner = isMobile ? '/images/rewards-program/banner-m.webp' : '/images/rewards-program/banner.webp';

  return (
    <div className='relative'>
      <Image
        src={banner}
        width={isMobile ? 375 : 1920}
        height={isMobile ? 200 : 370}
        className='w-full'
        alt=''
        unoptimized
        priority
      />

      <div className='block bg-[#EFEFEF] p-[20px] lg_hidden'>
        <h1 className='font-poppins text-[30px] font-[700] uppercase text-title'>FEED THE BIRDS, EARN THE REWARDS </h1>
        <p className='mt-[10px] font-sans text-title'>
          Join the Kingsyard Rewards Program and enjoy exclusive perks every time you shop or share your love of
          birding.
        </p>
      </div>
    </div>
  );
};

export default TopBanner;
